goog.provide('el8.appchart.visitNote.textarea');

goog.require('el8.uiwidget.alert');
goog.require('el8.util.string');

el8.appchart.visitNote.textarea = function(spec) {
    this._isInit = false;
    this._saveFn = spec.saveFn || function() {};
    this._removeFn = spec.removeFn || function() {};
    this._id = null;
    this._editId = null;
    this._infoField = null;
    this._separator = spec.separator || '\n';
    this._rows = spec.rows || 7;
    this._wrapperClass = spec.wrapperClass || 'el8FieldShortLabelPadding';
    this._shouldItemHighlightFn = spec.shouldItemHighlightFn || function() { return false; };
    this._lastSavedText = '';
    this._form = spec.form;

    // the very first time _initLastSavedText is run, it will set _lastSavedText to the note's initial value
    var that = this;
    this._initLastSavedText = _.once(function(text) {
        that._lastSavedText = text;
    });
};

el8.appchart.visitNote.textarea.prototype.hasId = function() {
    return Boolean(this._id);
};

el8.appchart.visitNote.textarea.prototype._doSave = function(opts) {

    if (!this._infoField) { return; }
    opts = opts || {};

    /* Default async, unless we don't have an ID yet, in which case,
     * we want to force it synchronous to avoid the situation where bullet 1
     * is still saving (so we have no ID) when we create bullet 2 (which
     * also tries to create a brand new bullet) and end up with duplicate bullets.
     * Amendments are like having no ID yet, because we'll get a new bullet ID each request */
    var async;
    if (!this._id || this._editId) {
        async = false;
    } else {
        async = (opts.async !== false);
    }

    var that = this;
    if (this._infoField.getVal()) {

        // remove emoji
        this._infoField.setVal(el8.util.string.cleanMultiByteChars(this._infoField.getVal()));

        this._saveFn(this._id, this._infoField.getVal(), 0 /* index */, {
            successCb: function(item) {
                that._id = item.getId();
                that._lastSavedText = item.getText();
                if (opts.successCb) { opts.successCb(); }
                that._infoField.setBlueHighlight(false);
            },
            errorCb: function() {
                /* In the case of encountering an error saving a textarea, we want to alert the user
                 * because if the bullet we're attempting to save to is deleted, then nothing
                 * is getting saved of the user's work here */
                el8.uiwidget.alert('This note was updated in another window. Please refresh the page to get the updates.');
                if (that._form && that._form.getButtonSet()) {
                    that._form.getButtonSet().disable();
                }
            },
            async: async
        });
    } else if (this._id) {
        // If have an ID and is empty, delete
        this._removeFn(this._id);
        this._id = null;
    }
};

el8.appchart.visitNote.textarea.prototype.init = function(infoField) {
    if (this._isInit) { return; }
    this._infoField = infoField;
    var that = this;
    var $inputField = this._infoField.getInputField();
    $inputField.on('change', function(event) {
        that._doSave();
    }).attr('rows', this._rows);

    // Add a wrapper around the textarea
    $inputField.wrap('<div class="el8TextareaWrap '+this._wrapperClass+'">'); // XSS OK -KF

    this._isInit = true;
    return this;
};

el8.appchart.visitNote.textarea.prototype.addEntry = function(item, successCb) {
    var needsSave = false;
    var textToAdd = item.getText();
    if (this._id) {
        /* If we're running into a second saved bullet here (a different ID),
         * then what we do is delete that second bullet on the server (right below),
         * and then take the text from the now-deleted bullet and concatenate it into
         * the textarea (later in this function) so it gets saved as part of
         * the current bullet and we no longer have colliding bullets.
         */
        if (item.getId() && (item.getId() !== this._id)) {
            this._removeFn(item.getId());
        }
        needsSave = true;
    } else if (item.getId()) {
        this._id = item.getId();
        needsSave = false;
        this._initLastSavedText(textToAdd);
    } else {
        needsSave = true;
    }
    this._editId = item.getEditId();

    if (this._infoField.getVal()) {
        this._infoField.setVal(
            this._infoField.getVal() + this._separator + textToAdd
        );
    } else {
        this._infoField.setVal(textToAdd);
    }

    // determines if we want to show the blue highlight on the text field/input
    if (this._shouldItemHighlightFn(item)) {
        this._infoField.setBlueHighlight(true);
    } else {
        this._infoField.setBlueHighlight(false);
    }

    if (needsSave) {
        this._doSave({ successCb: successCb });
    } else if (successCb) {
        successCb();
    }
};

el8.appchart.visitNote.textarea.prototype.isDirty = function() {
    return (this._infoField.getVal() !== this._lastSavedText);
};

el8.appchart.visitNote.textarea.prototype.saveIfDirty = function() {
    if (this.isDirty()) {
        this._doSave({ async: false });
    }
};

el8.appchart.visitNote.textarea.prototype.getJsonData = function() {
    var val = this._infoField.getVal();
    if (val) {
        return [{
            text: val
        }]
    } else {
        return null;
    }
};
